// components/BackgroundMusic.jsx
import { useEffect, useImperativeHandle, useRef, forwardRef } from "react";
import useFlowStore from "../store/flowStore";

const BackgroundMusic = forwardRef(({ src, volume = 0.5, loop = true }, ref) => {
  const audioRef = useRef();
  const muted = useFlowStore((s) => s.backgroundMusicMuted);

  useImperativeHandle(ref, () => ({
    play: () => {
      const audio = audioRef.current;
      if (!audio) return;

      audio.loop = loop;
      audio.volume = muted ? 0 : volume;
      audio
        .play()
        .catch((err) =>
          console.warn("⚠️ Impossible de jouer la musique :", err)
        );
    },
    pause: () => {
      audioRef.current?.pause();
    },
  }));

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = muted ? 0 : volume;
    }
  }, [muted, volume]);

  return <audio ref={audioRef} src={src} preload="auto" />;
});

export default BackgroundMusic;
